import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: false,
})
export class TruncatePipe implements PipeTransform {
  private static readonly DEFAULT_LENGTH = 20;
  private static readonly DEFAULT_TRAIL = '...';

  public transform(value: string, args: any[]): string {
    const limit = args.length > 0 ? parseInt(args[0], 10) : TruncatePipe.DEFAULT_LENGTH;
    const trail = args.length > 1 ? args[1] : TruncatePipe.DEFAULT_TRAIL;
    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
}
